<template>
  <div class="detail-ctn">
    <detail-page></detail-page>
  </div>
</template>
<script>
import DetailPage from '../components/detail/DetailPage'

export default {
  name: 'detail',

  components: {
    'detail-page': DetailPage
  }
}
</script>